export const ACTION = {
    GET_CONTACT_US_CONTENT: 'GET_CONTACT_US_CONTENT',
    GET_CONTACT_US_VISIT_US_CONTENT:'GET_CONTACT_US_VISIT_US_CONTENT',
    GET_CONTACT_US_RELATIONSHIP_OFFICER_CONTENT:'GET_CONTACT_US_RELATIONSHIP_OFFICER_CONTENT',
    GET_CHIEF_INFORMATION_CONTENT: 'GET_CHIEF_INFORMATION_CONTENT',
    GET_CONTACT_US_OFFICES_LIST_FILTER:'GET_CONTACT_US_OFFICES_LIST_FILTER',
    GET_CONTACT_US_OFFICES_LIST:'GET_CONTACT_US_OFFICES_LIST',
    GET_STAKEHOLDER_INFORMATION_HELPDESK:'GET_STAKEHOLDER_INFORMATION_HELPDESK',
    office_state_city:'office_state_city',
};



